import React from 'react';
import { MarkupElement } from 'src/api/models/MarkupHtml';
import { AttachmentComponents } from './HtmlAttachmentComponents/AttachmentsHtmlComponents';
import { structureHtmlData } from './functions/structureHtmlData';
import renderHtmlComponents from './functions/renderHtmlComponents';

interface RawHtmlComponentsProps {
  contentHtmlAst: MarkupElement[];
  attachments: AttachmentComponents | null;
}

const RawHtmlComponents = ({ contentHtmlAst }: RawHtmlComponentsProps): any => {
  const structuredHtmlData = structureHtmlData(contentHtmlAst);
  const renderedHtmlComponents = renderHtmlComponents(structuredHtmlData);

  return <>{renderedHtmlComponents}</>;
};

export default RawHtmlComponents;
